import styled from 'styled-components'

export const Container = styled.div`
  padding: 20px;
  height: 100%;
`

export const Union = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`

export const Footer = styled.footer`
  width: auto;
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: flex-end;
`
